module.exports = __webpack_public_path__ + "6fa7fcb384fa2df4fe22380b9dc5ba0f.pdf";